<template>
  <svg :viewBox="`${this.left} -${this.bottom} ${this.width} ${this.height}`">
    <g :style="`transform-origin: 50% -50%; transform: scale(${scale})`">
    <g :transform="`scale(1,-1) translate(0,${this.ship.particulars.B+this.margin})`">
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -4.2829904,6.6909873 C 16.933854,3.4804663 19.361169,-0.0275615 35.349527,0')"
        id="path1624"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 149.12277,6.6909926 157.84879,19.295341')"
        id="path1630"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 141.27078,0 C 145.53696,0 149.63334,-0.1327535 152.77575,2.1828006 153.71352,2.873807 154.71802,4.1444065 154.41484,5.2691103 154.18079,6.1373237 152.94019,6.8003267 152.12351,6.6928289 151.01248,6.5465866 149.12391,5.7775143 149.12277,6.6909926')"
        id="path1632"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="caasc" />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 127.05441,27.784406 H 114.16789 L 114.16762,22.008194')"
        id="path1634"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="ccc" />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 140.63099,31.656588 H 127.05423')"
        id="path1640"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -1.6394195,0.2577383 H 1.1381547')"
        id="path1642"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 35.349539,0 H 4.6441336')"
        id="path1644"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 1.1381547,0.2577383 1.8836196,5.6846851')"
        id="path1646"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 140.63099,31.656588 139.3666,27.784406')"
        id="path1648"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -2.0963164,5.0017187 -1.6394195,0.2577383')"
        id="path1650"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -4.2829904,6.6909873 H 149.12277')"
        id="path1652"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 1.8836196,5.6846851 4.6441336,0')"
        id="path1654"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 139.3666,27.784406 141.3202,19.686835')"
        id="path1656"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 127.05423,31.656588 127.05441,27.784406')"
        id="path1658"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -3.0604634,22.008194 -4.2829904,13.796617 V 6.6909873')"
        id="path1660"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        inkscape:connector-curvature="0"
        sodipodi:nodetypes="ccc" />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -3.0604634,22.008194 H 114.16762')"
        id="path1662"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M -2.0963164,5.0017187 -4.2829904,6.6909873')"
        id="path1664"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 141.3202,19.686835 157.84879,19.295341')"
        id="path1668"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
      <path
        data-v-45984ac4=""
        :d="scaleXZpath('M 35.349539,0 H 141.27078')"
        id="path1670"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
        />
    </g>

    <g :transform="`scale(1,-1) translate(0,${0.5*this.ship.particulars.B})`">
      <path
        :d="`M ${scaleXY(-4.7,12)} C ${scaleXY(0,12.5)} ${scaleXY(10,12.85)} ${scaleXY(30,12.85)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(30,12.85)} L ${scaleXY(135,12.85)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(157.4,0)} C ${scaleXY(157.4,10)} ${scaleXY(145,12.85)} ${scaleXY(135,12.85)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(-4.7,-12)} C ${scaleXY(0,-12.5)} ${scaleXY(10,-12.85)} ${scaleXY(30,-12.85)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(30,-12.85)} L ${scaleXY(135,-12.85)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(157.4,0)} C ${scaleXY(157.4,-10)} ${scaleXY(145,-12.85)} ${scaleXY(135,-12.85)}`"
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(-4.7,12)} L ${scaleXY(-4.7,-12)}` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
      <path
        :d="`M ${scaleXY(114.2,12.85)} L ${scaleXY(114.2,-12.85)} L ${scaleXY(141.3,-12.85)} L ${scaleXY(141.3,12.85)} Z` "
        :style="`fill:none;stroke:#000000;stroke-width:${0.3*lppScale/scale};`"
      />
    </g>

    <ShipFlettners 
      v-if="rotors" 
      :ship="ship" 
      :rotors="rotors" 
      :margin="margin"
      :xPositions="xPositions"
      :scaleX="scaleX"
      :scaleY="scaleY"
      :scaleZ="scaleZ"
      :scaleXY="scaleXY"
      :scaleXZ="scaleXZ"
      :lppScale="lppScale"
      @onToggleRotor="toggleRotor"
    />
    </g>
  </svg>
</template>

<script>

import ShipFlettners from "./ShipFlettners";

export default {
  name: "ShipRoPax",
  data: function() {
    return {
      Lpp: 150.0,
      Lwl: 154.2,
      Loa: 162.7,
      B: 25.7,
      T: 6.5,
      D: 22.0,
      relMargin: 0.025,
      xPositions: [10, 40, 70, 100]
    };
  },
  components: {
    ShipFlettners
  },
  props: {
    ship: Object,
    rotors: Object,
    withRotors: Boolean,
    scale: Number
  },
  methods: {
    scaleXZpath: function(path) {
      const tok = path.split(" ")
      path = ""
      const isAlpha  = /^[A-Z]+$/;
      for (let i=0; i<tok.length; i++){
        if (isAlpha.test(tok[i])) {
          path += " " + tok[i]
        }
        else {
          var coord = tok[i].split(",").map(parseFloat)
          if (coord.length == 2) {
            path += " " + this.scaleXZ(coord[0],coord[1])
          }
          else{
            if (tok[i-1] === 'H') {
              path += " " + this.scaleX(coord[0])
            }
            else {
              path += " " + this.scaleZ(coord[0])
            }
          }

            //             path = path.substr(0,path.length-2)+ " L"
            //   path += " " + this.scaleXZ(prevCoord[0]+coord[0],prevCoord[1])
            //   prevCoord = [prevCoord[0]+coord[0],prevCoord[1]]
            // }
            // else {
            //   path = path.substr(0,path.length-2)+ " L"
            //   path += " " + this.scaleXZ(prevCoord[0],prevCoord[1]+coord[0])
            //   prevCoord = [prevCoord[0],prevCoord[1]+coord[0]]
        }
      }
      return path.substr(1)
    },
    scaleXY: function(x, y) {
      return this.scaleX(x) + "," + this.scaleY(y);
    },
    scaleXZ: function(x, z) {
      return this.scaleX(x) + "," + this.scaleZ(z);
    },
    scaleX: function(x) {
      if (x > 0.0 && x < this.Lpp) {
        return (x / this.Lpp) * this.ship.particulars.Lpp;
      } else if (x >= this.Lpp) {
        const Lfwd = this.ship.particulars.Loa - this.ship.particulars.Lwl;
        const refLwfd = this.Loa - this.Lwl;
        return this.ship.particulars.Lpp + ((x - this.Lpp) / refLwfd) * Lfwd;
      } else {
        const Laft = this.ship.particulars.Lwl - this.ship.particulars.Lpp;
        const refLaft = this.Lwl - this.Lpp;
        return (x / refLaft) * Laft;
      }
    },
    scaleY: function(y) {
      return y/this.B*this.ship.particulars.B
    },
    scaleZ: function(z) {
      if (z <= this.T) {
        return (z / this.T) * this.ship.particulars.T;
      } else if (z < this.D) {
        return (
          this.ship.particulars.T +
          ((z - this.T) / (this.D - this.T)) *
            (this.ship.particulars.D - this.ship.particulars.T)
        );
      } else {
        return (
          this.ship.particulars.D +
          ((z - this.D) / this.Lpp) * this.ship.particulars.Lpp
        );
      }
    },
    toggleRotor: function(rotor) {
      this.$emit('toggleRotor', rotor)
    }
  },
  computed: {
    lppScale: function() {
      return this.ship.particulars.Lpp / 150.0;
    },
    margin: function() {
      return this.ship.particulars.Loa * this.relMargin
    },
    shipHeight: function() {
      if (!this.rotors) {
        return this.scaleZ(31.7);
      }
      return Math.max(this.scaleZ(31.7),this.ship.particulars.D+this.rotors.h)
    },
    bottom: function() {
      return this.shipHeight+2*this.margin+this.ship.particulars.B
    },
    height: function() {
      return this.shipHeight+3*this.margin+this.ship.particulars.B
    },
    width: function() {
      return this.ship.particulars.Loa+2*this.margin
    },
    left: function() {
      return this.ship.particulars.Lpp-this.ship.particulars.Lwl-this.margin
    },
    sideRotorDist: function(){
      return 0.5*this.ship.particulars.B-1.2*this.rotors.D
    }
  },
  // mounted() {
  //   this.$nextTick(function() {
  //     this.onResize(null);
  //       window.addEventListener('resize', this.onResize);
  //   })
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.onResize);
  // }
};
</script>

<style scoped>
/* svg path {
  shape-rendering: optimizeSpeed ;
} */
</style>